import _ from 'lodash'; 

export default class Utilities {
    static isNull(obj): boolean {
        if ((obj === 0) || (obj === false) || (obj === "")) {
            return false;
        }
        return (!obj || typeof obj === 'undefined' || obj === null);
    }

    static isNullOrEmpty(obj): boolean {
        return this.isNull(obj) || obj === '';
    }

    static isArrayNullOrEmpty(obj): boolean {
        if (!_.isArray(obj)) {
            return true;
        }

        return this.isNullOrEmpty(obj) || obj.length == 0 || obj.filter(o => !this.isNullOrEmpty(o)).length == 0;
    }
}